export const deezerID =
  process.env.NODE_ENV === 'production'
    ? '22e6eeea-f393-f011-ad1d-02f62e5b8e69'
    : 'f0a41e1f-0988-f011-ad1d-02f62e5b8e69';
